import { render, staticRenderFns } from "./zong.vue?vue&type=template&id=41947a9e&scoped=true"
import script from "./zong.vue?vue&type=script&lang=js"
export * from "./zong.vue?vue&type=script&lang=js"
import style0 from "./zong.vue?vue&type=style&index=0&id=41947a9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41947a9e",
  null
  
)

export default component.exports